import Vue from 'vue'

/**
 * @author Jose Luis R
 * Agree policy
 */

export default () =>
  Vue.$http.put(`/users/current/confidentiality_and_data_processing_letter/`)
    .then((res) => res.data)
